import { render, staticRenderFns } from "./homeVideo.vue?vue&type=template&id=5633a6fa&scoped=true&"
import script from "./homeVideo.vue?vue&type=script&lang=js&"
export * from "./homeVideo.vue?vue&type=script&lang=js&"
import style0 from "./homeVideo.vue?vue&type=style&index=0&id=5633a6fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5633a6fa",
  null
  
)

export default component.exports